"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isoDateTime = void 0;
exports.msToIso = msToIso;
exports.isoToMs = isoToMs;
/**
 * Reusable Zod schemas and the wire-timestamp conversion helpers for the oRPC
 * contract.
 *
 * `isoDateTime` is the single source of truth for how the v2 API represents a
 * timestamp on the wire: an RFC 3339 / ISO 8601 UTC string with a `Z` suffix
 * (e.g. `"2024-04-25T00:26:40.000Z"`). Zod's `z.iso.datetime` defaults to
 * `offset: false`, so offset-bearing forms like `+01:00` are rejected. We
 * deliberately do not constrain fractional-second precision — clients may send
 * any precision (or none), per "be liberal in what you accept"; our own writes
 * go through `msToIso`, which emits millisecond precision. Every timestamp
 * field in the contract should use this (nullable fields as
 * `isoDateTime.nullable()`) so the format stays consistent and the generated
 * OpenAPI document marks the field `format: "date-time"`.
 *
 * `msToIso` / `isoToMs` are the runtime counterpart to that schema, living in
 * `@repo/shared` so both the client and server mappers can cross the epoch-ms
 * boundary without reaching into a server-only util.
 */
const z = __importStar(require("zod"));
exports.isoDateTime = z.iso.datetime();
/** Epoch milliseconds → the RFC 3339 UTC string `isoDateTime` expects. */
function msToIso(ms) {
    return new Date(ms).toISOString();
}
/** Inverse of `msToIso`: an `isoDateTime` string → epoch milliseconds. */
function isoToMs(iso) {
    return new Date(iso).getTime();
}
//# sourceMappingURL=schemas.js.map